export const START_SESSION_DONE = 'START_SESSION_DONE';
export const CLOSING_SESSION_DONE = 'CLOSING_SESSION_DONE';
//# sourceMappingURL=actionTypes.js.map